import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-property-form-page',
  templateUrl: './property-form-page.component.html',
  styleUrls: ['./property-form-page.component.css']
})
export class PropertyFormPageComponent {
  // STEPPER

  activeStep = 0;

  propertyTypes = ['Apartment', 'Villa', 'Plot', 'Commercial'];
  listingTypes = ['Sale', 'Rent', 'Lease'];
  furnishingOptions = ['Unfurnished', 'Semi-Furnished', 'Fully Furnished'];
  facingOptions = ['North', 'South', 'East', 'West'];
  ownershipTypes = ['Freehold', 'Leasehold', 'Co-operative'];
  userRoles = ['Owner', 'Agent']
  amenitiesList = [
    { name: 'Swimming Pool', icon: 'bi-water' },
    { name: 'Gym', icon: 'bi-dumbbell' },
    { name: 'Parking', icon: 'bi-car-front' },
    { name: 'Lift', icon: 'bi-arrow-up-square' },
    { name: 'Power Backup', icon: 'bi-lightning-charge' },
    { name: 'Wi-Fi', icon: 'bi-wifi' },
    { name: 'CCTV', icon: 'bi-camera-video' },
    { name: 'Security', icon: 'bi-shield-lock' },
    { name: 'Fire Safety', icon: 'bi-fire' },
    { name: 'Children’s Play Area', icon: 'bi-emoji-smile' },
    { name: 'Garden', icon: 'bi-tree' },
    { name: 'Clubhouse', icon: 'bi-house-door' },
    { name: 'Community Hall', icon: 'bi-people' },
    { name: 'Jogging Track', icon: 'bi-shoe-prints' },
    { name: 'Basketball Court', icon: 'bi-basket3' },
    { name: 'Tennis Court', icon: 'bi-joystick' },
    { name: 'Badminton Court', icon: 'bi-circle-square' },
    { name: 'Indoor Games', icon: 'bi-controller' },
    { name: 'Visitor Parking', icon: 'bi-person-check' },
    { name: 'Intercom Facility', icon: 'bi-telephone' },
    { name: 'Rainwater Harvesting', icon: 'bi-cloud-drizzle' },
    { name: 'Water Supply', icon: 'bi-droplet' },
    { name: 'Maintenance Staff', icon: 'bi-person-gear' },
    { name: 'Housekeeping', icon: 'bi-broom' },
    { name: 'Laundry Service', icon: 'bi-basket2' },
    { name: 'Gas Pipeline', icon: 'bi-pipeline' },
    { name: 'ATM', icon: 'bi-credit-card' },
    { name: 'Shopping Center', icon: 'bi-bag' },
    { name: 'School Nearby', icon: 'bi-book' },
    { name: 'Hospital Nearby', icon: 'bi-hospital' },
    { name: 'Metro Connectivity', icon: 'bi-train-front' },
    { name: 'Pet Friendly', icon: 'bi-paw' },
    { name: 'Smart Home Features', icon: 'bi-cpu' },
    { name: 'Wheelchair Access', icon: 'bi-person-wheelchair' },
    { name: 'Solar Panels', icon: 'bi-sun' },
    { name: 'Private Terrace', icon: 'bi-house' },
    { name: 'Servant Room', icon: 'bi-person' },
    { name: 'Conference Room', icon: 'bi-easel' },
    { name: 'Banquet Hall', icon: 'bi-building' },
    { name: 'Library', icon: 'bi-journal-bookmark' },
    { name: 'Spa/Sauna', icon: 'bi-droplet-half' },
    { name: 'Barbecue Area', icon: 'bi-fire' },
    { name: 'Open Air Theater', icon: 'bi-film' }
  ];

  steps = [
    { title: 'Property Info', content: 'Details about the overview section.', icon: 'bi bi-house-door' },
    { title: 'Property Details', content: 'Details about the schedule section.', icon: 'bi bi-calendar2-week' },
    { title: 'Amenities', content: 'Information about the details section.', icon: 'fa-solid fa-dice' },
    { title: 'Listing Info', content: 'Review all the provided information.', icon: 'fa-solid fa-circle-info' },
    { title: 'User Roles', content: 'Review all the provided information.', icon: 'fa-solid fa-user' },
    { title: 'Photos/Videos', content: 'Review all the provided information.', icon: 'fa-solid fa-photo-film' },
    { title: 'Documents', content: 'Review all the provided information.', icon: 'fa-solid fa-file' }
  ];

  propertyForm = new FormGroup({
    title: new FormControl('', Validators.required),
    description: new FormControl(''),
    propertyType: new FormControl('', Validators.required),
    listingType: new FormControl('', Validators.required),
    city: new FormControl(''),
    state: new FormControl(''),
    locality: new FormControl(''),
    address: new FormControl(''),
    pincode: new FormControl(''),
    latitude: new FormControl(''),
    longitude: new FormControl(''),
    status: new FormControl(''),
    listedOn: new FormControl(''),
    ownerUserId: new FormControl(0),
    propertyId: new FormControl(0),
    actionUser: new FormControl(0),
  });

  // Step 1 - PropertyDetails
  propertyDetailsForm = new FormGroup({
    detailId: new FormControl(0),
    propertyId: new FormControl(0),
    bhk: new FormControl(0),
    superArea: new FormControl(0),
    carpetArea: new FormControl(0),
    furnishing: new FormControl(''),
    floorNumber: new FormControl(0),
    totalFloors: new FormControl(0),
    ageOfConstruction: new FormControl(0),
    facing: new FormControl(''),
    ownershipType: new FormControl(''),
    isActive: new FormControl(1)
  });

  // Step 2 - PropertyAmenities
  propertyAmenitiesForm = new FormGroup({
    amenity: new FormControl(''),
    amenityId: new FormControl(0),
    propertyId: new FormControl(0),
    isActive: new FormControl(1)
  });

  // Step 3 - PropertyListing
  propertyListingForm = new FormGroup({
    listingId: new FormControl(0),
    propertyId: new FormControl(0),
    listingType: new FormControl(''),
    price: new FormControl(0),
    maintenanceCharge: new FormControl(0),
    depositAmount: new FormControl(0),
    availableFrom: new FormControl(''),
    postedBy: new FormControl(0),
    listingStatus: new FormControl(''),
    isActive: new FormControl(1),
  });

  // Step 4 - UserRoleInProperty
  userRoleForm = new FormGroup({
    recordId: new FormControl(0),
    propertyId: new FormControl(0),
    userId: new FormControl(0),
    role: new FormControl(''),
    isPrimary: new FormControl(1),
    fullName: new FormControl(''),
    contactNumber: new FormControl(''),
    email: new FormControl(''),
    agencyName: new FormControl(''),
    reraRegistrationNo: new FormControl(''),
    verified: new FormControl(1),
    isActive: new FormControl(1),
  });

  // Step 5 - PropertyMedia
  propertyMediaForm = new FormGroup({
    mediaType: new FormControl(''),
    filePath: new FormControl(''),
    caption: new FormControl(''),
    isPrimary: new FormControl('')
  });

  // Step 6 - PropertyDocument
  propertyDocumentForm = new FormGroup({
    documentType: new FormControl(''),
    filePath: new FormControl(''),
    verified: new FormControl('')
  });

  formGroups: FormGroup[] = [
    this.propertyForm,
    this.propertyDetailsForm,
    this.propertyAmenitiesForm,
    this.propertyListingForm,
    this.propertyDocumentForm,
    this.propertyMediaForm,
    this.userRoleForm
  ];








  setStep(index: number): void {
    this.activeStep = index;
  }

  overviewData = {
    name: '',
    email: '',
    phone: '',
    notes: ''
  };

  submitOverview() {
    console.log('Overview Form Submitted:', this.overviewData);
    // You can add further logic like validation, API call, etc.
  }

  cancelStep(): void {
    // Optional: Clear data or navigate away
    this.overviewData = {
      name: '',
      email: '',
      phone: '',
      notes: ''
    };
    this.activeStep = 0; // or navigate back or reset
  }
  goToNextStep() {
    if (this.activeStep < this.steps.length - 1) {
      this.activeStep++;
    }
  }

  propertyData = { area: '', builtYear: '', floorNumber: '', totalFloors: '', furnishing: '', facing: '' };
  pricingData = { price: '', bookingAmount: '', availableFrom: '', maintenance: '', security: '' };

    selectedAmenities: string[] = [];
    toggleAmenity(name: string) {
    const index = this.selectedAmenities.indexOf(name);
    if (index > -1) {
      this.selectedAmenities.splice(index, 1);
    } else {
      this.selectedAmenities.push(name);
    }

    const joined = this.selectedAmenities.join(', ');
    this.propertyAmenitiesForm.get('amenity')?.setValue(joined);
  }

  isAmenitySelected(name: string): boolean {
    return this.selectedAmenities.includes(name);
  }


  submitPropertyDetails() {
    const {
      area,
      builtYear,
      floorNumber,
      totalFloors,
      furnishing,
      facing
    } = this.propertyData;

    // Basic validation
    if (!area || !builtYear || !floorNumber || !totalFloors || !furnishing) {
      alert("Please fill all required fields in Property Details.");
      return;
    }

    // Log or process the data (replace with your logic)
    console.log("Property Details Submitted:", this.propertyData);

    // Move to next step
    this.goToNextStep();
  }

  BackStep() {
    if (this.activeStep > 0) {
      this.activeStep--;
    }
  }


  stepImages: string[] = [
    'assets/images/calendar.png',      // Step 0
    'assets/images/property.png',      // Step 1
    'assets/images/summary.png',       // Step 2
    // Add more images if you have more steps
  ];

  charCount = 0;

  updateCharCount() {
    const desc = this.propertyForm.get('description')?.value || '';
    this.charCount = desc.length;
  }

  getErrorMessage(field: string): string {
    const control = this.propertyForm.get(field);
    if (!control || !control.errors) return '';

    if (control.errors['required']) return 'This field is required.';
    if (control.errors['minlength']) return `Minimum ${control.errors['minlength'].requiredLength} characters required.`;
    if (control.errors['maxlength']) return `Maximum ${control.errors['maxlength'].requiredLength} characters allowed.`;
    if (control.errors['pattern']) return 'Invalid format.';

    return 'Invalid field.';


  }

  handleNumberTypeFocus(controlName: string) {

  }

  handleNumberTypeBlur(controlName: string) {

  }

  

  imagePreviews: string[] = [];
documentNames: string[] = [];
uploadedImages: File[] = [];
uploadedDocuments: File[] = [];

onImageUpload(event: Event): void {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length) {
    this.uploadedImages = Array.from(input.files);
    this.imagePreviews = this.uploadedImages.map(file => URL.createObjectURL(file));

  }
}
removeImage(index: number): void {
  this.uploadedImages.splice(index, 1);
  this.imagePreviews.splice(index, 1);
  this.propertyMediaForm.patchValue({ });
}

onDocumentUpload(event: Event): void {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length) {
    this.uploadedDocuments = Array.from(input.files);
    this.documentNames = this.uploadedDocuments.map(file => file.name);

  }
}

submitMedia(): void {
  const formData = new FormData();

  this.uploadedImages.forEach((file, i) => formData.append(`images[${i}]`, file));
  this.uploadedDocuments.forEach((file, i) => formData.append(`documents[${i}]`, file));

  // Example: send formData to your API

}


}
